export default {
  groupsDisabled(state) {
    return (state.accessUser.groups &&
      state.accessUser.groups.filter(group => group.active === false)) || [];
  },
  groupsEnabled(state) {
    return (state.accessUser.groups &&
      state.accessUser.groups.filter(group => group.active === true)) || [];
  },
  profilesDisabled(state) {
    return (state.accessUser.profiles &&
      state.accessUser.profiles.filter(profile => profile.active === false)) || [];
  },
  profilesEnabled(state) {
    return (state.accessUser.profiles &&
      state.accessUser.profiles.filter(profile => profile.active === true)) || [];
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-users/store/getters.js